module.exports = __webpack_public_path__ + "img/hr-green-small-grass-06.6a4494ab.png";